// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Fwxkj","content":"styles_content__oZisT","sideBar__active":"styles_sideBar__active__7L3gL","main":"styles_main__lUc1A"};